import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./almThickness.png"

const ベースコアの厚み = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { almThickness: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="ベース／コアの厚み" helpURL={HELP_LINKS["ベース／コアの厚み"]} src={img}>
      <RadioGroup
        name={FIELD_NAMES["ベース／コアの厚み"]}
        selectedValue={values.almThickness}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["ベース／コアの厚み"]["0.8mm"].value}>0.8mm</Radio>
          <Radio value={ESTIMATE_CONSTANT["ベース／コアの厚み"]["1.0mm"].value}>1.0mm</Radio>
          <Radio value={ESTIMATE_CONSTANT["ベース／コアの厚み"]["1.5mm"].value}>1.5mm</Radio>
          <Radio value={ESTIMATE_CONSTANT["ベース／コアの厚み"]["2.0mm"].value}>2.0mm</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.almThickness} />
    </OneClickField>
  )
}

export default ベースコアの厚み
